module.exports = __webpack_public_path__ + "static/media/logo.7c0ef0ea.svg";